import Head from '../../layouts/Head';
import Blog1Container from '../../containers/Blog1';
import Footer from '../../layouts/Footer';

const Blog1 = () => {

  return (
    <>
		<Head Title='Blog1' />
		<Blog1Container />
		<Footer />
    </>
  );
}

export default Blog1;

